export default "__VITE_ASSET__4a66d6e7__"